import { Box, styled } from '@creditas-ui/react'
import React, { Children, cloneElement } from 'react'

const AccordionBox = styled(Box)`
  margin: 0 -20px 0 -20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[10]};

  @media screen and (min-width: 980px) {
    margin: auto;
  }
`

const AccordionSummary = styled(Box)`
  cursor: pointer;
`

const AccordionItem = ({
  component = 'div',
  isOpen,
  key,
  callback,
  testId,
  children: childrenProp,
  ...props
}) => {
  const [summary, ...children] = React.Children.toArray(childrenProp)

  return (
    <AccordionBox component={component} key={key} {...props}>
      <AccordionSummary as="div" onClick={callback} data-testid={testId}>
        {Children.map(summary, child => {
          return cloneElement(child, {
            isOpen,
          })
        })}
      </AccordionSummary>
      {Children.map(children, child => {
        return cloneElement(child, {
          isOpen,
        })
      })}
    </AccordionBox>
  )
}

export { AccordionItem }
